interface EmptyStateProps {
  title: string;
  desc?: string;
  actionText?: string;
  onAction?: () => void;
}

export default function EmptyState({
  title,
  desc,
  actionText,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center bg-background-50 rounded-lg border border-background-200">
      <span className="w-16 h-16 rounded-full bg-background-100 text-foreground-300 flex items-center justify-center text-3xl mb-4">
        <i className="ri-inbox-archive-line" />
      </span>
      <h3 className="font-heading text-lg font-semibold text-foreground-900">{title}</h3>
      {desc && <p className="mt-2 text-sm text-foreground-500 max-w-md">{desc}</p>}
      {actionText && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 h-10 px-5 rounded-md bg-primary-600 text-background-50 text-sm font-medium hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          {actionText}
        </button>
      )}
    </div>
  );
}